import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class HttpLoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.show();   // Mostrar el loader cuando se haga una solicitud HTTP

    // Se maneja la solicitud HTTP y se usa 'finalize' para ocultar el loader cuando la solicitud haya finalizado
    return next.handle(req).pipe(
      finalize(() => {
        // Oculta el loader después de que la solicitud haya sido completada (ya sea exitosa o con error)
        this.loaderService.hide();
      })
    );
  }
}
